import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { showInfoNotification } from './components/NotificationManager';
import axios from 'axios';

// Set global axios timeout to 30 seconds (instead of default 8 seconds)
axios.defaults.timeout = 30000;


const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const waitForSWActivation = (registration) => {
  if (!registration?.waiting) return;

  // Tell the waiting SW to skip waiting
  registration.waiting.postMessage({ type: 'SKIP_WAITING' });

  // Listen for the new SW to take control before reloading
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
};

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Show a brief notification that an update is being applied
    showInfoNotification("New version available! Updating...", {
      duration: 2,
      autoClose: true
    });

    // Automatically apply the update after a short delay
    setTimeout(() => {
      waitForSWActivation(registration);
    }, 2000);
  },

  onSuccess: () => {
    // console.log('✅ Service worker successfully registered.');
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }
});

reportWebVitals();
